import { getImagesBySizes } from './getImagesBySizes';
import type { Img, TImageOriginFull } from './types';

/**
 * Получить массив изображений без дублей (по ширине) и отсортированные
 * в порядке возрастания
 * @param sizes
 * @returns
 */
// * Фильтрует и сортирует массив размеров изображений:
// * 1. Удаляет изображения с пустым URL
// * 2. Убирает дубликаты по ширине
// * 3. Сортирует по возрастанию ширины
export function getUniqueAndSortedSizes(sizes: Img[]): Img[] {
  const unique = sizes
    // попадались картинки с пустым url
    .filter((size: Img) => size.url)
    .reduce(
      (result: Record<string, Img>, size: Img) => ({
        ...result,
        [size.width]: size,
      }),
      {} as Record<string, Img>,
    );

  return Object.values(unique).sort((a, b) => a.width - b.width);
}

// * Генерирует наборы изображений для разных значений DPR (Device Pixel Ratio):
// * Для каждого DPR (1x, 2x и т.д.) подбирает изображения с учетом умножения размеров
export function getImagesByDPR(sizesUsed: number[], sizesImages: Img[], maxDPR = 2) {
  const arrayDPR = Array.from({ length: maxDPR }, (_, i) => i + 1);

  const imagesByDPR = arrayDPR.reduce(
    (result: Record<string, Img[]>, DPR: number) => {
      const firstSizes: number[] = result['1x']
        ? result['1x'].map((image: Img) => image.width * DPR)
        : sizesUsed.map((sizeUsed: number) => sizeUsed * DPR);

      return {
        ...result,
        [`${DPR}x`]: getImagesBySizes(firstSizes, sizesImages),
      };
    },
    {} as Record<string, Img[]>,
  );

  return imagesByDPR;
}

// * Приводит изображение к стандартному формату:
export const getOriginImageFormat = function (origin: string | Img | undefined): Img {
  if (typeof origin === 'undefined') {
    return {
      url: '',
      width: 0,
      height: 0,
    };
  }

  return typeof origin === 'string'
    ? {
        url: origin,
        width: 0,
        height: 0,
      }
    : {
        url: origin.url || '',
        width: origin.width,
        height: origin.height,
      };
};

// * Создает объект изображения в полном формате на основе массива размеров:
// * Используется для приведения данных к единому формату
export const getImageFormatFromSizes = function (sizes: Img[], alt = ''): TImageOriginFull {
  return {
    image_id: 0,
    origin: sizes.at(-1)?.url || '',
    sizes,
    alt
  };
};
